document.addEventListener('DOMContentLoaded',function() {
    
    window.waypoints = function() {
        
        if (document.querySelector('.js-privacyindex')) {
            const navmagenta = document.querySelector('.js-privacyindex').querySelectorAll('[data-target]');
            const observerElements = document.querySelectorAll('.js-waypoint');
            const observerOptions = {
                root: null,
                rootMargin: '-49% 10px',
                threshold: 0
            };
            
            const Observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.intersectionRatio > 0) {
                            let id = entry.target.id;
                            
                            if (navmagenta) {
                                for (let i = 0; i < navmagenta.length; i++) {
                                    navmagenta[i]. classList.remove('is-active');
                                }
                            }
                            
                            setTimeout(function() {
                               document.querySelector("li[data-target='#"+id+"']").classList.add('is-active');
                            }, 10);
                        }
                        
                    });
                }, 
                observerOptions
            );
    
            observerElements.forEach(el => {
                Observer.observe(el);
            });
        }
    };
    
    
}, false);
